import React, {useEffect, useRef, useState} from "react";
import Container from "@mui/material/Container";
import {Avatar, Button, Grid, IconButton, InputAdornment, Stack, Typography} from "@mui/material";
import {Lock} from "@mui/icons-material";
import AlertBar from "../../components/AlertBar";
import Form from "../../components/Form";
import InputField from "../../components/InputField";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Box from "@mui/material/Box";
import {Navigate, useNavigate} from "react-router-dom";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";

export default function LoginPage(props) {
    const navigate = useNavigate();
    const form = useRef();
    const alert = useRef();
    const emailRef = useRef();
    const passwordRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [hasSignedIn, setHasSignedIn] = useState(false);

    useEffect(() => {
        localStorage.clear();
    }, []);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const submit = () => {
        let data = {
            email,
            password
        };
        if (!isSubmitting && form.current.validate()) {
            setIsSubmitting(true);
            alert.current.showProgress("");
            window.axios
                .post(`${BASE_URL}auth/login`, data)
                .then((response) => {
                    alert.current.hide();
                    setIsSubmitting(false);
                    alert.current.showSuccess("Login Successfully");
                    localStorage.clear();
                    const user = response.data;
                    localStorage.setItem("system_user", user);
                    localStorage.setItem("system_token", user.api_token);
                    window.$user = user;

                    setTimeout(() => {
                        if (user?.employee?.firstLoginStatus === "active") {
                            navigate('/verification');
                        } else {
                            setHasSignedIn(true);
                        }
                    }, 2000);
                })
                .catch((error) => {
                    setIsSubmitting(false);
                    reportErrors(alert.current, error);
                });
        }
    }

    return (
        hasSignedIn ? <Navigate to={{pathname: "/private/dashboard"}}/> :
            <Container disableGutters maxWidth="sm" component="main" sx={{pt: 12, pb: 6}}>
                <Grid item xs={12} container justifyContent="center" alignItems="center">
                    <Box sx={{p: {xs: 2, sm: 3, md: 4, xl: 5}}}>
                        <Grid item>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Stack sx={{mb: {xs: -0.5, sm: 0.5}}} alignItems={"center"} spacing={2}>
                                        <Avatar sx={{width: 45, height: 45}}><Lock/></Avatar>
                                        <Typography variant="h4">Sign in</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12}>
                                    <AlertBar ref={alert}/>
                                    <Form ref={form}>
                                        <Grid container spacing={1.5}>
                                            <Grid item xs={12}>
                                                <InputField
                                                    ref={emailRef}
                                                    required={true}
                                                    type="email"
                                                    label="Email Address"
                                                    onChange={(value) => setEmail(value)}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <InputField
                                                    ref={passwordRef}
                                                    required={true}
                                                    type={showPassword ? 'text' : 'password'}
                                                    label="Enter password"
                                                    onChange={(value) => setPassword(value)}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                onMouseDown={handleMouseDownPassword}
                                                                edge="end"
                                                                size="large"
                                                            >
                                                                {showPassword ? <VisibilityOffIcon/> :
                                                                    <RemoveRedEyeIcon/>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button
                                                    disableElevation
                                                    disabled={isSubmitting}
                                                    fullWidth
                                                    size="large"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => submit()}
                                                >
                                                    Sign in
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button
                                                    disableElevation
                                                    disabled={isSubmitting}
                                                    fullWidth
                                                    size="large"
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => navigate("/register-account")}
                                                >
                                                    Dont have an account. Sign up Today
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Container>
    );
}